import { OrdersMock } from 'commons/mocks/order';
import { TYPE_STATUS_ITEM } from 'commons/types';
import { IOrder } from 'commons/types/order';
import { Content } from 'commons/types/user';

import { FIGURANTS_EXCEED_LIMIT, ORDER_STATUS_ID_BY_STATUS } from 'commons/constants';
import { NO_TAX } from 'commons/constants/addendum';
import { cleanObject, dateFormatter } from 'commons/utils';
import { IValues } from 'pages/OrdersFiltered/@types';
import { getService, patchService, postService, putService } from './comfiguraServiceApi';
import { unmountScript } from './script';

export const getOrderToPdf = async ({
  orderId,
  agencyId,
  shouldRenderedInEmpty,
}: {
  orderId: string;
  agencyId: number | string;
  shouldRenderedInEmpty: boolean;
}) => {
  const response = getService(`${shouldRenderedInEmpty ? 'blanck-' : ''}authorization-term`, {
    params: {
      OrderId: orderId,
      AgencyId: agencyId,
    },
  });
  return response;
};

interface IFilters {
  content?: string;
  idPedido?: string;
  statusPedido?: string;
  nomeAssistente?: string;
  dataInicioGravacao?: Date | null;
  dataFimGravacao?: Date | null;
  idAgencia?: string;
  ordenarPor?: string;
  recordingAt?: string;
}

export const getOrders = async ({
  content,
  profile,
  currentPage,
  filters,
}: {
  content?: string;
  profile: number;
  currentPage: number;
  filters?: IFilters;
}) => {
  const { recordingAt, dataInicioGravacao, dataFimGravacao, ...otherFilters } = filters || {};
  return getService(`orders?profile=${profile}&pageNumber=${currentPage}`, {
    params: {
      content: content,
      ...cleanObject(otherFilters || {}),
      dataInicioGravacao:
        recordingAt || dataInicioGravacao
          ? recordingAt === 'another' && dataInicioGravacao
            ? dateFormatter(dataInicioGravacao, 'MM-dd-yyyy')
            : dateFormatter(new Date(), 'MM-dd-yyyy')
          : null,
      dataFimGravacao:
        recordingAt || dataFimGravacao
          ? recordingAt === 'another' && dataFimGravacao
            ? dateFormatter(dataFimGravacao, 'MM-dd-yyyy')
            : dateFormatter(recordingAt, 'MM-dd-yyyy')
          : null,
    },
  });
};

export const getOrdersByAgencyId = async ({
  agencyId,
  status,
  orderId,
  content,
  createAt,
  recordingAt,
  startRecordingDate,
  endRecordingDate,
  currentPage,
}: any): Promise<{
  orders: IOrder[] | [];
  pages: number;
}> => {
  const isMock = false;

  if (isMock) {
    const OrdersMockFiltered = {
      orders: OrdersMock.filter(order => !agencyId || order.agencyId === agencyId),
      pages: 1,
    };
    return Promise.resolve(OrdersMockFiltered);
  }

  const response = await getService('orders-by-agency', {
    params: {
      pageNumber: currentPage,
      idAgencia: agencyId,
      statusPedido: ORDER_STATUS_ID_BY_STATUS[status],
      idPedido: orderId,
      conteudo: content.value !== 'all' ? content?.label : null,
      ordenarPor: createAt?.value,
      dataInicioGravacao:
        recordingAt || startRecordingDate
          ? recordingAt === 'another'
            ? dateFormatter(startRecordingDate, 'MM-dd-yyyy')
            : dateFormatter(new Date(), 'MM-dd-yyyy')
          : null,
      dataFimGravacao:
        recordingAt || endRecordingDate
          ? recordingAt === 'another'
            ? dateFormatter(endRecordingDate, 'MM-dd-yyyy')
            : dateFormatter(recordingAt, 'MM-dd-yyyy')
          : null,
    },
  });
  return response?.data;
};

export const getOrdersByFilter = async (params: IValues): Promise<IOrder[] | []> => {
  const response = await getService('orders-by-agency-and-date', { params });
  return response?.data;
};

export const cancelOrder = async ({
  id,
  form,
}: {
  id: number;
  form: {
    taxaAdendo: number;
    descricaoAdendo: string;
  };
}) => {
  const isMock = false;

  if (isMock) {
    return Promise.resolve({ id });
  }

  if (form.taxaAdendo === NO_TAX) {
    const response = await patchService(`order/${id}/cancel`);
    return response;
  }

  const response = await postService('adendo-cancelamento', {
    idPedidoOriginal: id,
    ...form,
  });
  return response;
};

interface ITask {
  description: string;
  chargeable: boolean;
  endDate: string;
  id: number;
  level: number;
  number: string;
  parentId: null;
  parentNumber: null;
  projectId: number;
  startDate: string;
  children: ITask[];
}
export interface IScript {
  cenas: [];
  dataHoraFimRefeicaoRoteiro: null;
  dataHoraFimRoteiro: null;
  dataHoraInicioRoteiro: string;
  dataHoraRefeicaoRoteiro: null;
  dataHoraSaidaRoteiro: null;
  dataRoteiro: string;
  horaFinalGravacao: null;
  horaInicioAlmoco: null;
  horaInicioGravacao: null;
  horaSaidaGravacao: null;
  idRoteiro: number;
  localGravacao: null;
  localGravacaoRoteiro: {
    endereco: string;
    nome: string;
  };
  numero: number;
  tipoRoteiro: 0 | 1 | 2 | 3;
  scenesCount: number;
}

export interface Item {
  agency: {
    cnpj: string;
    id: number;
    isActive: boolean;
    name: string;
  } | null;
  agencyId: string;
  typeId: string;
  type: {
    category: string;
    profile: string;
  } | null;
  arrivedTime: string;
  amount: number | string;
  unitCost: number;
  totalCosts: number;
  notes: string;
  status: string;
  orderId: string;
  id?: number;
  entity_id?: number;
  taxaAdministrativaPorFigurante: number;
  tarifaPorFigurante: number;
  impostoPorFigurante: number;
}
export interface IRequestFigurantForm {
  orderDate?: string;
  id?: number;
  content: Content;
  project: {
    businessUnit: { id: string; description: string };
    id: number;
    name: '';
    number: '';
    sourceCode: null;
    status: string;
  } | null;
  area: string;
  areas: string[];
  costCenter: string;
  task: string;
  Tasks: { tasks: ITask[]; selected: ITask }[];
  purpose: string;
  hasScript: boolean | string;
  script: IScript | null;
  scenesCount: number;
  recordingType: { label: string; value: string };
  recordingPlace: string;
  recordingDate: string;
  recordingTime: string;
  backgroundActorPresentationPlace: string;
  recordingNotes: string;
  userLoggedEmail: string;
  userLoggedName: string;
  totalCosts: number;
  items: Item[];
  newItem: Item;
  editItem?: Item;
  status: string;
  descricaoAdendo?: string;
  taxaAdendo?: string;
  scriptFigAmount?: number;
  emailProdutorExecutivo?: string;
  justificativaAssistenteDirecao?: string;
  overorder?: boolean;
}

const editFigurantRequestBody = ({
  recordingType,
  recordingDate,
  recordingPlace,
  recordingTime,
  scenesCount,
  script,
  project,
  area,
  areas,
  task,
  items,
  editItem,
  newItem,
  orderDate,
  status,
  id,
  content,
  scriptFigAmount,
  emailProdutorExecutivo,
  overorder,
  userLoggedEmail,
  userLoggedName,
  ...restValues
}: IRequestFigurantForm) => {
  const hasScript = restValues.hasScript === 'true';

  const orderFigurantsQuantity = items.reduce((prev, curr) => prev + Number(curr.amount), 0);
  const exceedQuantity = hasScript
    ? (scriptFigAmount || 0) + orderFigurantsQuantity > FIGURANTS_EXCEED_LIMIT
    : orderFigurantsQuantity > FIGURANTS_EXCEED_LIMIT;
  const pedidoExcedente = exceedQuantity;

  const unmountScriptData = unmountScript({
    hasScript,
    script,
    recordingType: recordingType?.value,
    recordingDate,
    recordingPlace,
    recordingTime,
  });

  const itemsData = items.map(({ type, status, orderId, ...item }) => ({
    ...item,
    type: type?.profile,
    orderId,
    agencyId: item.agency?.id,
  }));

  const totalCosts = items.reduce((total, item) => total + item.totalCosts, 0);

  const tasks = areas?.join(' > ');

  const [firstAgency] = itemsData;
  const agencyId = firstAgency?.agencyId;

  const body = {
    ...restValues,
    ...unmountScriptData,
    id,
    projectId: project?.id,
    project: project?.name,
    area: tasks,
    totalCosts,
    items: itemsData,
    content: content.name,
    agencyId,
    pedidoExcedente,
    emailProdutorExecutivo: emailProdutorExecutivo || null,
  };

  return body;
};

export const editOrder = async (payload: any) => {
  const isMock = false;

  if (isMock) return Promise.resolve({});

  const response = await putService(`order/${payload?.id}`, editFigurantRequestBody(payload));

  return response;
};

export const getOrderById = async (id: string | undefined) => {
  const isMock = false;

  if (isMock) return Promise.resolve({});

  const response = await getService(`orders-by-id/${id}`);
  return response;
};

export interface IOrderCover {
  id: number;
  script: string;
  content: string;
  totalCosts: number;
  recordingType: string;
  expectedFiscal: number;
  recordingNotes: string;
  recordingPlace: string;
  userLoggedName?: string;
  userLoggedEmail: string;
  backgroundTotal?: number;
  expectedQuantity: number;
  status: TYPE_STATUS_ITEM;
  startRecordingDate: string;
  expectedCompanions: number;
  expectedBackgroundActor: number;
  expectedBackgroundActorPet: number;
  expectedBackgroundActorMinor: number;
  expectedBackgroundActorVehicle: number;
  backGroundActorPresentationDate: string;
  backGroundActorPresentationPlace: string;
  items: {
    agency: {
      id: number;
      name: string;
    };
    id: number;
    taxa: number;
    type: string;
    notes: string;
    amount: number;
    orderId: number;
    unitCost: number;
    totalCosts: number;
    arrivedTime: string;
    status: TYPE_STATUS_ITEM;
  }[];
}

export const getOrderCover = async ({
  orderId,
  agencyId,
}: {
  orderId: string;
  agencyId?: number;
}): Promise<IOrderCover> => {
  const response = await getService(`order-cover/${orderId}`, {
    params: {
      agencyId,
    },
  });
  return response?.data;
};
